const domainCampaign = process.env.REACT_APP_BASE_URL;
const END_POINTS = {
  GET_CODE: domainCampaign + "/psqr/psqrcodes",
  GET_CAMPAIGN_INFO: domainCampaign + "/psqr/campaigns/check",
  GET_GIFT_SUMMARY: domainCampaign + "/psqr/gifts",
  REQUEST_OTP: domainCampaign + "/psqr/otps",
  ADD_GREETING: domainCampaign + "/psqr/psqrcodes/addgreeting",
  TAKE_GIFT: domainCampaign + "/psqr/gifts/take",
  VERIFY_OTP: domainCampaign + "/psqr/otps/verify",
  GET_BLOCK_LIST: domainCampaign + "/psqr/blocklist"
 
};

export { END_POINTS };
